var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#39BF8F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,57.3c-0.8,0.3-1.7,0.7-2.6,1l-4.9,1.6c-12.3,4-18.8,0.7-22.8-11.7L2.6,36c-4-12.3-0.7-18.8,11.6-22.8 l4.8-1.6c-0.6,1.5-1.1,3.2-1.6,5.1l-3,13C11,44.3,16,52.4,30.6,55.9l5.2,1.2C36.2,57.2,36.5,57.2,36.9,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.1,4.7l-5.2-1.2c-10.4-2.5-16.5-0.4-20.2,7.1c-0.9,1.9-1.7,4.2-2.3,6.8l-3,13c-3,13,1,19.4,13.9,22.4 l5.2,1.2c1.8,0.4,3.5,0.7,5,0.8c9.7,0.9,14.8-3.6,17.4-14.8l3-13C65.1,14.2,61.1,7.8,48.1,4.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.582896058cc501c4eb725f2d8dd56c96.svg";
export { ForwardRef as ReactComponent };